import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function WhyFailedSection() {
  return <SectionWrapper alternate data-id="element-514">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-4" variants={childVariants} data-id="element-515">
        Why what you've tried failed
      </motion.h2>

      <motion.p className="font-heading text-lg text-cream-muted italic mb-10" variants={childVariants} data-id="element-516">
        (and it's not your fault)
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-517">
        Because most solutions:
      </motion.p>

      <motion.ul className="space-y-5 mb-10" variants={childVariants} data-id="element-518">
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-519">
       <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-520" />
          <div data-id="element-521">
            <span data-id="element-522">
              Focus on falling asleep… not getting back to sleep at 3am
            </span>
          
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-523">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-524" />
          <div data-id="element-525">
            <span data-id="element-526">Add more decisions</span>
            <br data-id="element-527" />
            <span className="text-cream-muted" data-id="element-528">
              ("try this… or this… or this…")
            </span>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-529">
          <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-530" />
          <div data-id="element-531">
            <span data-id="element-532">
              Ignore the anxiety loop that begins the second you think:
            </span>
            <br data-id="element-533" />
            <em className="text-amber" data-id="element-534">"Oh no."</em>
          </div>
        </li>
        <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-535">
         <span className="mt-2 w-2 h-2 rounded-full bg-amber flex-shrink-0" data-id="element-536" />
          <div data-id="element-537">
            <span data-id="element-538">
          Accidentally train your brain that 3am = clock-checking + phone time
          </span>
           </div>
        </li>
      </motion.ul>

      <motion.p className="font-heading text-xl text-teal-light font-medium leading-relaxed-plus" variants={childVariants} data-id="element-539">
        This ebook reverses that training.
      </motion.p>
    </SectionWrapper>;
}